
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"56","height":"56","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('path',{attrs:{"id":"id-33a","d":"M0 0h56v56H0z"}}),_c('path',{attrs:{"id":"id-36d","d":"M9.58 17.666v-1.02c0-1.757.65-2.671 2.953-4.007 2.39-1.424 3.727-3.305 3.727-5.994C16.26 2.777 13.043 0 8.227 0 3.006 0 .14 3.023 0 7.154h4.13c.141-2.18 1.6-3.568 3.868-3.568 2.215 0 3.691 1.353 3.691 3.217 0 1.74-.738 2.69-2.918 4.008-2.425 1.423-3.445 3.005-3.287 5.607l.018 1.248H9.58zm-1.986 8.262c1.424 0 2.549-1.108 2.549-2.496 0-1.389-1.125-2.479-2.55-2.479-1.423 0-2.566 1.09-2.566 2.479 0 1.388 1.143 2.496 2.567 2.496z"}}),_c('filter',{attrs:{"id":"id-35c","width":"186.1%","height":"154%","x":"-43.1%","y":"-19.3%","filterUnits":"objectBoundingBox"}},[_c('feOffset',{attrs:{"dy":"2","in":"SourceAlpha","result":"shadowOffsetOuter1"}}),_c('feGaussianBlur',{attrs:{"in":"shadowOffsetOuter1","result":"shadowBlurOuter1","stdDeviation":"2"}}),_c('feColorMatrix',{attrs:{"in":"shadowBlurOuter1","values":"0 0 0 0 0 0 0 0 0 0.286648489 0 0 0 0 0.383463542 0 0 0 0.312445367 0"}})])]),_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('mask',{attrs:{"id":"id-34b","fill":"#fff"}},[_c('use',{attrs:{"xlink:href":"#id-33a"}})]),_c('circle',{attrs:{"cx":"28","cy":"28","r":"28","fill":"#97E1FA","mask":"url(#id-34b)"}}),_c('g',{attrs:{"mask":"url(#id-34b)"}},[_c('g',{attrs:{"transform":"translate(20 15)"}},[_c('use',{attrs:{"fill":"#000","filter":"url(#id-35c)","xlink:href":"#id-36d"}}),_c('use',{attrs:{"fill":"#FFF","xlink:href":"#id-36d"}})])])])])
          )
        }
      }
    